var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('media-library',{attrs:{"headers":[
      'type',
      'filename',
      'name',
      'description',
      'category',
      'textbookIssue',
      'licenses',
      'isDownloadable',
      'file',
      'actions' ],"textbook":_vm.activeTextbook,"textbook-issue-id":_vm.$route.params.textbookIssueId,"show-textbook-issue-filter":true,"show-license-filter":true,"show-category-filter":true,"zip-import":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }